import React from "react";
import styled from "styled-components";
import moment from "moment";
import PdfView from "../candidateAssessmentPdf";
const Wrapper = styled.div`
    display: flex;
    height: 90px;
    padding:0 30px;

    border-bottom: 1px solid #efeff0;
`;
const InviteeDetail = styled.div`
    display: flex;
    /* flex: 3; */
    width: 40%;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
`;
const InviteeStatus = styled.div`
    display: flex;
    /* flex: 7; */
    width: 60%;
    justify-content: space-evenly;
    align-items: center;
`;
const StatusValue = styled.div`

    border-radius: 4px;
    font-size: 11px;
    height: 100%;
    /* margin-top: 18px; */
    display: flex;
    flex: 1;
    align-items: center;
    &>p{
        margin: 0;
        color: ${(props) =>
        props.status === "Attempted"
            ? "#FFA91B"
            : props.status === "Submitted"
            ? "#21C17A"
            : "#939599"};
    background-color: ${(props) =>
        props.status === "Attempted"
            ? "#FFF6E8"
            : props.status === "Submitted"
            ? "#E8F8F1"
            : "#E3E4E5"};
    border: 1px solid
        ${(props) =>
            props.status === "Attempted"
                ? "#FFA91B"
                : props.status === "Submitted"
                ? "#21C17A"
                : "#C8CACC"};
        padding: 0 4px;
        width: fit-content;
    }
`;
const ScoreValue = styled.p`
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    color: #1e2228;
    display: flex;
    flex: 1;
`;
const DateValue = styled.p`
    font-size: 12px;
    font-weight: 400;
    color: #1e2228;
    display: flex;
    flex: 1;
`;
const PdfWrapper=styled.div`
    display: flex;
    flex: 1;
    align-items: center;
`

const InterViewInviteeCard = ({ data,nameRequired }) => {
    return (
        <Wrapper>
            <InviteeDetail>
                <p style={{ fontWeight: "700", fontSize: "14px", margin: 0 }}>
                    {data.name}
                </p>
                <p style={{ fontWeight: "400", fontSize: "12px", margin: 0 }}>
                    {data.email}
                </p>
            </InviteeDetail>
            {/* <InviteeStatus> */}
            <StatusValue status={data.status}>
                <p>{data.status}</p>
            </StatusValue>
            <ScoreValue>
                {data?.status?.toUpperCase() === "SUBMITTED"
                    ? data.attemptedCheck
                        ?  data?.gptCheck
                            ? `${data.candidate_marks.toFixed(2)}%`
                            : "Report in progress"
                        : "0%"
                    : "-"}
            </ScoreValue>
            <DateValue>
                {data.created_at?moment(data.created_at).format("DD") +
                    " " +
                    moment(data.created_at).format("MMM") +
                    " " +
                    moment(data.created_at).format("YY"):"-"}
            </DateValue>
            <PdfWrapper >
                {data.status === "Submitted" ? (
                    data.attemptedCheck ? (
                        (data?.gptCheck) ? (
                            <PdfView
                                id={data?.candidate_assessment_id}
                                nameRequired={nameRequired}
                                disable={false}
                                name={data.name}
                            />
                        ) : (
                            <PdfView
                                id={data?.candidate_assessment_id}
                                disable={true}
                            />
                        )
                    ) : (
                        <PdfView
                                id={data?.candidate_assessment_id}
                                disable={false}
                                nameRequired={nameRequired}
                                name={data.name}
                            />
                    )
                ) : (
                    <div>-</div>
                )}
            </PdfWrapper>

            {/* </InviteeStatus> */}
        </Wrapper>
    );
};

export default InterViewInviteeCard;
